import axios from "axios";
import { OAuthErrorBody } from "@markit/common.types";

const NETWORK_MESSAGE =
  "We couldn't reach Markit. Check your connection and try again.";

/** HTTP status of a failed API call, or undefined if no response came back. */
export const getApiErrorStatus = (err: unknown): number | undefined =>
  axios.isAxiosError(err) ? err.response?.status : undefined;

/**
 * The user-facing message from a failed API call. Reads Markit's { error }
 * body as well as the OAuth endpoints' RFC 6749 { error_description }.
 */
export const getApiErrorMessage = (err: unknown): string => {
  if (!axios.isAxiosError(err)) {
    return err instanceof Error ? err.message : String(err);
  }
  if (!err.response) {
    return NETWORK_MESSAGE;
  }
  // Markit's own { error } body is the same shape minus error_description.
  const body = err.response.data as Partial<OAuthErrorBody> | undefined;
  return (
    body?.error_description ||
    body?.error ||
    `Request failed (${err.response.status})`
  );
};
